<script setup>
const demoPages = [
  {
    key: 'datetime-picker-demo',
    title: 'DateTimePicker Demo',
    description: 'Componente per selezione Data+Ora compatibile con database SQL e Laravel (v-time-picker).',
    path: '/dev/DateTimePickerDemoPage',
    access: 'Public',
  },
  {
    key: 'time-slot-demo',
    title: 'Time Slot Demo',
    description: 'Configuratore completo per testare DateTimePickerUnified e varianti di scheduling.',
    path: '/dev/TimeSlotDemoPage',
    access: 'Public',
  },
  {
    key: 'listing-form-details-parallel-demo',
    title: 'Listing Form + Details Parallel Demo',
    description: 'Confronto a due colonne tra ListingForm e ListingDetails (offline con fixture, online con listing reali).',
    path: '/dev/ListingFormDetailsParallelDemoPage',
    access: 'Public / Surgeon Secretary',
  },
  {
    key: 'listing-table-bulk-actions-demo',
    title: 'ListingTable Bulk Actions Demo',
    description: 'Demo di selezione none/single/multiple e azione successiva orchestrata dal parent.',
    path: '/dev/ListingTableBulkActionsDemoPage',
    access: 'Public / Surgeon Secretary',
  },
]

definePage({
  meta: {
    layout: 'default',
    public: true,
  },
})
</script>

<template>
  <VContainer class="py-6">
    <VCard class="mb-6">
      <VCardTitle class="text-h5">
        Dev Demo Index
      </VCardTitle>
      <VCardSubtitle>
        Elenco delle pagine demo disponibili nel progetto.
      </VCardSubtitle>
    </VCard>

    <VRow>
      <VCol
        v-for="demo in demoPages"
        :key="demo.key"
        cols="12"
        md="6"
      >
        <VCard
          class="h-100 d-flex flex-column"
          variant="outlined"
        >
          <VCardTitle>{{ demo.title }}</VCardTitle>
          <VCardText class="text-body-2 flex-grow-1">
            {{ demo.description }}
          </VCardText>
          <VCardActions class="d-flex justify-space-between px-4 pb-4">
            <VChip
              size="small"
              variant="tonal"
            >
              {{ demo.access }}
            </VChip>
            <VBtn
              color="primary"
              :to="demo.path"
            >
              Apri demo
            </VBtn>
          </VCardActions>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>
